import React from 'react';
import PropTypes from 'prop-types';
import { Pressable, StyleSheet } from 'react-native';
import { isWeb } from '~global/screens';
import Colors from '~global/Colors';
import Image from '@web-components/common/Image';

const ArrowRight = (props) => {
  const { customStyle = {}, iconStyle = {}, onClick } = props;
  const icon = require('~assets/img/arrow-right-grey.svg');
  const arrow = isWeb ? { uri: icon } : icon;

  return (
    <Pressable
      style={[styles.arrow, styles.right, customStyle]}
      onPress={onClick}>
      <Image source={arrow} style={[styles.icon, iconStyle]} />
    </Pressable>
  );
};

ArrowRight.propTypes = {
  customStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  iconStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  onClick: PropTypes.func,
};

const ArrowLeft = (props) => {
  const { customStyle = {}, iconStyle = {}, onClick } = props;
  const icon = require('~assets/img/arrow-left-grey.svg');
  const arrow = isWeb ? { uri: icon } : icon;

  return (
    <Pressable
      style={[styles.arrow, styles.left, customStyle]}
      onPress={onClick}>
      <Image source={arrow} style={[styles.icon, iconStyle]} />
    </Pressable>
  );
};

ArrowLeft.propTypes = {
  customStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  iconStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  onClick: PropTypes.func,
};

export default {
  ArrowLeft,
  ArrowRight,
};

const styles = StyleSheet.create({
  arrow: {
    position: 'absolute',
    width: 32,
    height: 32,
    borderRadius: 100,
    backgroundColor: Colors.white,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: Colors.grey0,
    zIndex: 1,
    elevation: 2,
    top: 140,
  },
  icon: {
    width: 8,
    height: 13,
  },
  right: {
    marginRight: -15,
    right: 0,
  },
  left: {
    marginLeft: -15,
    left: 0,
  },
});
